export default {
  en: {
    title: 'Search all supplier answer notes',
    messageTitle: "Search your suppliers' answer notes",
    message:
      'Retrieve suppliers that include your search term in their answer notes. This is a new beta feature we are testing.',
    searchPlaceholder: 'Search term e.g. CrowdStrike...',
    beta: 'BETA',
    errorTitle: 'Error searching',
    errorMessage: "There was an error searching in the supplier's answer notes. Please try again.",
    emptyTitle: 'No suppliers',
    emptyDescription: "We didn't find any supplier with that search term in their answer notes",
    columns: {
      supplier: 'Supplier name',
    },
  },
};
